import ActionCable from 'actioncable';

class NotificationsSocket {
  constructor(uid, token, client, onUpdate) {
    // Each value is percent-encoded: a uid like `name+alias@x.com` would otherwise reach the server with the `+`
    // read as a space, and the cable rejects the connection without a word (so no live updates).
    const query = [
      ['uid', uid],
      ['token', token],
      ['client', client],
    ]
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&');
    const url = `${process.env.REACT_APP_CABLE_WSS_URL}?${query}`;
    this.cable = ActionCable.createConsumer(url);
    this.onUpdate = onUpdate;
  }

  subscribe(channel) {
    return this.cable.subscriptions.create(channel, {
      received: this.onUpdate,
    });
  }

  disconnect() {
    if (this.cable) {
      this.cable.disconnect();
    }
  }
}

export default NotificationsSocket;
